export default __webpack_public_path__ + "static/media/layer1.2ce1d723.svg";